/*
 * @Description: 所有请求的接口入口
 * @Author: gao shuai
 * @Date: 2020-02-25 15:35:05
 * @LastEditTime: 2020-07-28 15:12:39
 * @LastEditors: gao shuai
 */

import api from '../assets/js/apiRequestHandler';
export default {
  // 提现信息
  getMoney(params) {
    return api({
      url: '/api/Weixin/WithdrawApply',
      method: 'get',
      params: params
    });
  },
  // 提现申请
  applyMoney(params) {
    return api({
      url: '/api/Weixin/ConfirmWithdraw',
      method: 'get',
      params: params
    });
  },
  // 提现记录
  moneyRecord(params) {
    return api({
      url: '/api/Weixin/GetWithdrawRecord',
      method: 'get',
      params: params
    });
  },
  // 订单信息
  orderInfo(params) {
    return api({
      url: '/api/Weixin/GetTenantOrders',
      method: 'get',
      params: params
    });
  },
  // 分区统计
  areaStatic(params) {
    return api({
      url: '/api/Weixin/GetPartitionsAnalysis',
      method: 'get',
      params: params
    });
  },
  /* -----------------------1.整区补发---------------------- */
  // 游戏分区下拉
  gamelist(params) {
    return api({
      url: '/api/SelectDropDown/GetPartitionNameListAsync',
      method: 'get',
      params: params
    });
  },
  // 整区补单
  allOrder(params) {
    return api({
      url: '/api/ReissueRecords/AllReissueAsync',
      method: 'post',
      data: params
    });
  },
  // 整区补发列表
  allOrderList(params) {
    return api({
      url: '/api/ReissueRecords/GetReissueRecordsListAsync',
      method: 'get',
      params: params
    });
  },
  /* -----------------------2.手动补发---------------------- */
  // 充值方式下拉
  payDrow(params) {
    return api({
      url: '/api/SelectDropDown/GetPayModeNameListAsync',
      method: 'get',
      params: params
    });
  },
  // 手动补单
  handOrder(params) {
    return api({
      url: '/api/ReissueRecords/ManualReissueAsync',
      method: 'post',
      data: params
    });
  },
  /* -----------------------3.补发记录---------------------- */
  // 补发列表
  reorderList(params) {
    return api({
      url: '/api/ReissueRecords/GetReissueRecordsListAsync',
      method: 'get',
      params: params
    });
  },
  /* -----------------------4.分组管理---------------------- */
  // 获取分组list
  teamlist(params) {
    return api({
      url: '/api/Group/GetGroupListAsync',
      method: 'get',
      params: params
    });
  },
  // 删除分组
  deleteteam(params) {
    return api({
      url: '/api/Group/DeleteGourpAsync',
      method: 'post',
      data: params
    });
  },
  // 编辑分组
  editteam(params) {
    return api({
      url: '/api/Group/UpdateAsync',
      method: 'post',
      data: params
    });
  },
  // 添加分组
  addteam(params) {
    return api({
      url: '/api/Group/AddGroupAsync',
      method: 'post',
      data: params
    });
  },
  /* -----------------------5.分区管理---------------------- */
  // 分区列表
  arealist(params) {
    return api({
      url: '/api/PartitionsManager/GetPartitionsTemplatesListAsync',
      method: 'get',
      params: params
    });
  },
  // 所属分组下拉
  belongDrow(params) {
    return api({
      url: '/api/InstallPartition/GetGroups',
      method: 'get',
      params: params
    });
  },
  // 游戏模板下拉
  gameDrow(params) {
    return api({
      url: '/api/PartitionsManager/GetTemplateListAysnc',
      method: 'get',
      params: params
    });
  },
  // 批量删除分区管理
  delAreas(params) {
    return api({
      url: '/api/PartitionsManager/BatchDeletePartitionsManagerAsync',
      method: 'post',
      data: params
    });
  },
  // 批量排序分区管理
  sortAreas(params) {
    return api({
      url: '/api/PartitionsManager/BatchSortPartitionsManagerAsync',
      method: 'post',
      data: params
    });
  },
  // 获取分区详细信息
  getAreaInfo(params) {
    return api({
      url: '/api/PartitionsManager/GetPartitionDetailAsync',
      method: 'get',
      params: params
    });
  },
  // 修改分区
  editArea(params) {
    return api({
      url: '/api/PartitionsManager/UpdatePartitionAsync',
      method: 'post',
      data: params
    });
  },
  // 分区检测
  checkLink(params) {
    return api({
      url: '/api/PartitionsManager/CheckPartition',
      method: 'get',
      params: params
    });
  },
  // 加载分区
  loadingArea(params) {
    return api({
      url: '/api/PartitionsManager/LoadPartitionAsync',
      method: 'post',
      data: params
    });
  },
  /* -----------------------6.安装分区---------------------- */
  // 获取用户分组
  groupsdrow(params) {
    return api({
      url: '/api/InstallPartition/GetGroups',
      method: 'get',
      params: params
    });
  },
  // 获取服务器机器码
  getMachineCode(params) {
    return api({
      url: '/api/InstallPartition/GetMachineCode',
      method: 'get',
      params: params
    });
  },
  // 获取用户模板接口
  modelDrow(params) {
    return api({
      url: '/api/InstallPartition/GetTemplates',
      method: 'get',
      params: params
    });
  },
  // 安装分区
  partInstall(params) {
    return api({
      url: '/api/InstallPartition/Install',
      method: 'post',
      data: params
    });
  }
};
